import {GetStatesDentalGuide} from 'domain/usecases';
import {RemoteGetStatesDentalGuide} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {GuideFlowEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetStatesDentalGuide = (): GetStatesDentalGuide =>
	new RemoteGetStatesDentalGuide(
		makeBFFApiUrl(GuideFlowEndpoints.odontoGuideStates),
		makeAuthorizeHttpClientDecorator(),
	);
